export const formSumakomi = () => {
    $(function () {

        function setCal() {
            // 単価
            var clickTanka = 200;
            var impressionTanka = 2 * 12;


            // 各値初期化
            var impression = 0;
            var clickLimit = 0;
            var banner = $('input[name="banner"]:checked').val(); // バナー

            // バナー制作にチェックが入ったとき
            if (banner == 1) {
                $('.js-banner-data').val(30000);
                $('.js-banner').html('30,000円');
            } else {
                $('.js-banner-data').val(0);
                $('.js-banner').html('0円');
            }

            var money = Number($('input[name="money"]').val());

            $('.js-set--sumakomi-money').val(money); // form-calTotalに代入
            var bannerPrice = Number($('.js-banner-data').val());

            clickLimit = Math.floor(money / clickTanka)
            impression = Math.floor((money * 100) / (impressionTanka))

            $('.js-money-data').val(money);
            $('.js-money').html(money.toLocaleString() + '円');
            $('.js-click-limit').html(clickLimit + '回');
            $('input[name="sumakomiClickLimit"]').val(clickLimit);
            $('.js-impression').html(impression + '回');
            $('input[name="sumakomiImpression"]').val(impression);

            $('.js-sumakomi-subtotal').html((money + bannerPrice).toLocaleString());

        }

        setCal();


        /* ------------------------------------------------------------------------------
        *
        * 予算の入力をリアルタイムで検知
        *
        -----------------------------------------------------------------------------*/
        $(document).on('keyup', 'input[name="money"]', function (e) {
            // ----------------------------------
            // 価格テキスト箇所にローダーを回す
            // ----------------------------------
            // $('.js-money').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // 配信予算にローダーを回す
            // $('.js-impression').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // インプレッション回数にローダーを回す
            // $('.js-click-limit').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // クリック回数にローダーを回す
            // $('.js-sumakomi-subtotal').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // スマコミフォーム合計のローダーを回す
            // $('.js-cal-todal').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // 全合計のローダーを回す
            setCal();
            setCalTotalAll();
        });


        $(".js-click").on('click', function () {
            switch ($(this).data('item')) {
                case 'distance':
                    // ----------------------------------
                    // 配信距離1
                    // ----------------------------------
                    $('.js-set-sumakomi-distance').val($(this).data('distance'));
                    $('#overlay, .sumakomi-distance-modal, .sumakomi-distance-modal--ttl').fadeOut();
                    $('body').removeClass('modal-active');  // 本文の縦スクロールを有効
                    break;
            }
        });

        // ----------------------------------
        // バナー制作にチェックが入ったとき
        // ----------------------------------
        $('input[name="banner"]').on('change',function () {
            // ----------------------------------
            // 価格テキスト箇所にローダーを回す
            // ----------------------------------
            // $('.js-banner').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // バナー制作費にローダーを回す
            // $('.js-sumakomi-subtotal').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // スマコミフォーム合計のローダーを回す
            // $('.js-cal-todal').html('<img src="' + getTemplateDirectoryUri + '/assets/img/common/ajax-loader.gif">'); // 全合計のローダーを回す
            if ($('input[name="banner"]').prop('checked') == true) {
                $('.js-set--sumakomi-banner').val('1'); // form-calTotalに代入
            } else {
                $('.js-set--sumakomi-banner').val(''); // form-calTotalに代入
            }
            setCal();
            setCalTotalAll();
        });


    });

};